export function quoteHasFinalizedPurchase(quote = {}) {
  return Boolean(
    quote?.is_paid
      || quote?.is_credit
      || quote?.purchased_at
      || quote?.payment_status === 'payment_approved'
      || quote?.payment_status === 'credit_approved'
      || Number(quote?.total_purchase_orders || 0) > 0,
  )
}

export function quoteHasPaymentActivity(quote = {}) {
  return Boolean(
    quote?.is_paid
      || quote?.is_credit
      || quote?.payment_status === 'awaiting_payment_approval'
      || quote?.payment_status === 'payment_approved'
      || quote?.payment_status === 'credit_approved'
      || Number(quote?.total_purchase_orders || 0) > 0,
  )
}

export function requoteActionLabelKey(quote = {}) {
  return quoteHasPaymentActivity(quote) ? 'duplicateQuote' : 'updateQuote'
}
